import { TemplateItem } from "./templates.store";
import { TariffWithPricesViewType } from "../Catalogs/types";
import { ExtendedArticleEntityType } from "../Jobs/types";

export interface TemplateItemDetails {
	code_e: string;
	code: string;
	type: "Tarif" | "Artikel" | "Unbekannt";
	description: string;
	found: boolean;
}

export const getTemplateItemDetails = (
	item: TemplateItem,
	tariffsLookup: Record<string, Record<string, TariffWithPricesViewType>>,
	articlesLookup: Record<string, Record<string, ExtendedArticleEntityType>>
): TemplateItemDetails => {
	if (item.tariffs_default_id || item.tariffs_custom_id) {
		const tariffId = item.tariffs_custom_id || item.tariffs_default_id;
		for (const codeE in tariffsLookup) {
			const tariff = tariffsLookup[codeE][tariffId || ""];
			if (tariff) {
				return {
					code_e: tariff.code_e || item.code_e || "",
					code: tariff.code || tariff.code_e || item.code_e || "",
					type: "Tarif",
					description: tariff.description_de || item.code_e || "",
					found: true,
				};
			}
		}
	}

	if (item.article_id) {
		for (const codeE in articlesLookup) {
			for (const id in articlesLookup[codeE]) {
				if (articlesLookup[codeE][id].id === item.article_id) {
					const article = articlesLookup[codeE][id];
					return {
						code_e: article.code_e || item.code_e || "",
						code: article.code_e || item.code_e || "",
						type: "Artikel",
						description: article.description_de || item.code_e || "",
						found: true,
					};
				}
			}
		}
	}

	if (item.code_e) {
		const tariffsForCode = tariffsLookup[item.code_e];
		const articlesForCode = articlesLookup[item.code_e];
		if (tariffsForCode && Object.keys(tariffsForCode).length > 0) {
			const tariff = Object.values(tariffsForCode)[0];
			return {
				code_e: item.code_e,
				code: tariff?.code || item.code_e,
				type: "Tarif",
				description: tariff?.description_de || item.code_e,
				found: true,
			};
		}
		if (articlesForCode && Object.keys(articlesForCode).length > 0) {
			return {
				code_e: item.code_e,
				code: item.code_e,
				type: "Artikel",
				description: Object.values(articlesForCode)[0]?.description_de || item.code_e,
				found: true,
			};
		}
	}

	return {
		code_e: item.code_e || "",
		code: item.code_e || "",
		type: "Unbekannt",
		description: item.code_e || "",
		found: false,
	};
};
